import { useState, useEffect, useLayoutEffect } from "preact/hooks";
import { isValidValue } from "./checks";
import API, { graphqlOperation } from "@aws-amplify/api-graphql";
import Cache from "@aws-amplify/cache";

export function useWindowSize() {
  const [size, setSize] = useState(0);
  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

// function roughSizeOfObject(object) {
//   const objectList = [];
//   const stack = [object];
//   let bytes = 0;

//   while (stack.length) {
//     let value = stack.pop();

//     if (typeof value === "boolean") {
//       bytes += 4;
//     } else if (typeof value === "string") {
//       bytes += value.length * 2;
//     } else if (typeof value === "number") {
//       bytes += 8;
//     } else if (typeof value === "object" && objectList.indexOf(value) === -1) {
//       objectList.push(value);

//       for (let i in value) {
//         stack.push(value[i]);
//       }
//     }
//   }
//   return bytes;
// }

export async function getData(op, opName, params, getExpiryTime, isTopGames = false) {
  // Cache.clear();
  const cacheKey = opName + JSON.stringify(params);
  // console.log("Cache hit! ", Cache.getCacheCurSize());
  const obj = Cache.getItem(cacheKey);
  const data = obj?.data;
  if (isValidValue(data) && (!isValidValue(obj?.expiry) || obj?.expiry > Date.now())) {
    return data;
  }
  // console.log("Network request! ", opName);
  let response;
  try {
    response = await API.graphql(graphqlOperation(op, params));
  } catch {
    return data;
  }

  if (!isValidValue(response?.data)) {
    return data;
  }
  let responseData = isTopGames
    ? response?.data?.[opName]?.items?.[0]?.games
    : response?.data?.[opName];

  let output = responseData;
  if (responseData?.items) {
    let result = responseData.items;

    while (responseData?.nextToken) {
      params.nextToken = responseData?.nextToken;
      response = await API.graphql(graphqlOperation(op, params));
      responseData = isTopGames
        ? response?.data?.[opName]?.items?.[0]?.games
        : response?.data?.[opName];

      if (responseData?.items) {
        result = result.concat(responseData.items);
      }
    }
    if (Array.isArray(result) && result?.length === 1) {
      output = result[0];
    } else output = result;
  }
  let expiration = getExpiryTime !== undefined ? getExpiryTime(output) : 1.5 * 60 * 1000; // 1.5 min
  // 24 hours max cached time
  if (expiration > 24 * 3600 * 1000) {
    expiration = 24 * 3600 * 1000;
  }
  const expiryTime = new Date().getTime() + expiration;
  // console.log("response size - %s kb", roughSizeOfObject(output) / 1000);
  if (isValidValue(output)) Cache.setItem(cacheKey, { data: output, expiry: expiryTime });
  return output;
}

export function useFetch(
  op,
  opName,
  params = {},
  getExpiryTime = undefined,
  trigger = "",
  isTopGames = false
) {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (params != undefined) {
      if (Object.values(params)?.length > 0 && Object.values(params).some((s) => s == undefined)) {
        return;
      }
      getData(op, opName, params, getExpiryTime, isTopGames)
        .then((res) => {
          setResponse(res);
          setLoading(false);
        })
        .catch(() => {
          setHasError(true);
          setLoading(false);
        });
    }
  }, [opName, JSON.stringify(params), trigger, isTopGames]);

  return [response, loading, hasError];
}
